const SplitMapContext = React.createContext()

SplitMapContext.displayName = 'SplitMapContext'

export default SplitMapContext
